import { useUser } from "@/firebase";
import { subscriptionsDataQuery } from "@/services/queries";
import Boxes from "./Boxes";
import FAQ from "./FAQ";
import Features from "./Features";
import Footer from "./Footer";
import Header from "./Header";
import HeroImage from "./HeroImage";
import HowItWorks from "./HowItWorks";
// import OurImpact from "./OurImpact";
import MaifudLovers from "./MaifudLovers";
import MaifudStore from "./MaifudStore";
import Press from "./Press";
import Problem from "./Problem";

const Home = () => {
    const { data: response } = subscriptionsDataQuery({});
    const data = response?.data;
    const discountFormatted = data?.subscriptions[0].discount_formatted;
    const { user, isLoading: isLoadingUser } = useUser();

    return (
        <div className="bg-white">
            <Header
                discountFormatted={discountFormatted}
                user={user}
                isLoadingUser={isLoadingUser}
            />
            <HeroImage />
            <Features />
            <Boxes
                subscriptions={data?.subscriptions}
                showInitialDiscount={user == null && !isLoadingUser}
            />
            <HowItWorks />
            <MaifudStore />
            <Press />
            {/* <OurImpact /> */}
            <MaifudLovers />
            <Problem />
            <FAQ />
            <Footer />
        </div>
    );
};

export default Home;
